<!-- 인증회원 -->
<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <form @submit.prevent="submitForm">
        <div class="container">
          <div class="area_wrap">
            <div class="title_wrap">
              <h3>개인정보 입력</h3>
              <p class="warn">*필수입력정보입니다.</p>
            </div>
            <div class="aw_context">
<!--              <div class="article require" :class="{errorLaise : form.userName.hasError}">-->
<!--                <div class="inputHeader" v-if="form.userName.hasError">-->
<!--                  <p>이름</p>-->
<!--                  <span class="warn" v-text="form.userName.errorTxt"></span>-->
<!--                </div>-->
<!--                <input type="text" placeholder="이름" v-model="form.userName.value" maxlength="21" @keyup="blurName()" class="userInput"/>-->
<!--              </div>-->
              <div class="article require" :class="{errorLaise : form.id.hasError}">
                <div class="inputHeader" v-if="form.id.hasError">
                  <p>아이디</p>
                  <span class="warn"  v-text="form.id.errorTxt"></span>
                </div>
                <input type="text" placeholder="아이디" v-model="form.id.value" maxlength="21" @keyup="blurId()" class="idInput"/>
              </div>
<!--              <div class="article require" :class="{errorLaise : form.birthDate.hasError}">-->
<!--                <div class="inputHeader" v-if="form.birthDate.hasError">-->
<!--                  <p>생년월일</p>-->
<!--                  <span class="warn"  v-text="form.birthDate.errorTxt"></span>-->
<!--                </div>-->
<!--                <input type="text" placeholder="생년월일" v-model="form.birthDate.value" maxlength="10" @blur="blurBirth()" @keyup="formatBirthNumber(form.birthDate.value)" class="birthInput"/>-->
<!--              </div>-->
<!--              <div class="article require" :class="{errorLaise : form.tel.hasError}">-->
<!--                <div class="inputHeader" v-if="form.tel.hasError">-->
<!--                  <p>이메일</p>-->
<!--                  <span class="warn"  v-text="form.tel.errorTxt"></span>-->
<!--                </div>-->
<!--                <input type="text" placeholder="이메일" v-model="form.tel.value" maxlength="30" @keyup="blurEmail()" class="mailInput"/>-->
<!--              </div>-->
            </div>
          </div>
        </div>
        <div class="btnWrap" :class="{visible : form.userName.flag && form.id.flag && form.birthDate.flag && form.tel.flag}">
          <button type="submit" :disabled="!checkAll()">비밀번호 찾기</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapMutations, mapState } from 'vuex'
// import { Dert } from '@/assets/js/thanQAlert'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'another'
      },
      transDate: {
        headerName: '비밀번호 찾기',
        prevUrl: '/'
      },
      pwChecked: false,
      form: {
        id: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        userName: {
          value: ''
        },
        birthDate: {
          value: ''
        },
        tel: {
          value: ''
        }
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    blurName () {
      this.form.userName.flag = false
      this.checkName()
    },
    checkName () {
      if (this.form.userName.flag) return true

      const userName = this.form.userName.value
      if (userName === '') {
        this.form.userName.hasError = true
        this.form.userName.errorTxt = '이름을 입력해주세요'
        return false
      }
      // const isHan = /[ㄱ-ㅎ가-힣]/g
      // if (!isHan.test(userName)) {
      //   this.form.userName.hasError = true
      //   this.form.userName.errorTxt = '한글만 입력이 가능합니다.'
      //   return false
      // }
      this.form.userName.flag = true
      this.form.userName.hasError = false
      this.form.userName.errorTxt = ''
      return true
    },
    blurId () {
      this.form.id.flag = false
      this.checkId()
    },
    checkId () {
      if (this.form.id.flag) return true

      const userId = this.form.id.value
      if (userId === '') {
        this.form.id.hasError = true
        this.form.id.errorTxt = '아이디를 입력해주세요.'
        return false
      }
      // const isEng = /^[A-Za-z0-9+]*$/
      // if (!isEng.test(userId)) {
      //   this.form.id.hasError = true
      //   this.form.id.errorTxt = '영문과 숫자를 혼용하여 입력해주세요'
      //   return false
      // }
      this.form.id.flag = true
      this.form.id.hasError = false
      this.form.id.errorTxt = ''
      return true
    },
    blurBirth () {
      this.form.birthDate.flag = false
      this.checkBirth()
    },
    checkBirth () {
      if (this.form.birthDate.flag) return true

      const birth = this.form.birthDate.value
      if (birth === '') {
        this.form.birthDate.hasError = true
        this.form.birthDate.errorTxt = '생년월일을 입력해주세요.'
        return false
      }
      const isBirthDate = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
      if (!isBirthDate.test(birth)) {
        this.form.birthDate.hasError = true
        this.form.birthDate.errorTxt = '생년월일을 바르게 입력해주세요.'
        return false
      }
      this.form.birthDate.flag = true
      this.form.birthDate.hasError = false
      this.form.birthDate.errorTxt = ''
      return true
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.form.birthDate.value = this.formatBirth(obj)
    },
    blurEmail () {
      this.form.tel.flag = false
      this.checkEmail()
    },
    checkEmail () {
      if (this.form.tel.flag) return true

      const email = this.form.tel.value
      if (email === '') {
        this.form.tel.hasError = true
        this.form.tel.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
      const isEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!isEmail.test(email)) {
        this.form.tel.hasError = true
        this.form.tel.errorTxt = '이메일 형식에 맞지 않습니다.'
        return false
      }
      this.form.tel.flag = true
      this.form.tel.hasError = false
      this.form.tel.errorTxt = ''
      return true
    },
    checkAll () {
      return !!(this.form.userName.flag && this.form.id.flag && this.form.birthDate.flag && this.form.tel.flag)
    },
    nextDone () {
      const userData = {
        userName: this.form.userName.value,
        id: this.form.id.value,
        birthDate: this.form.birthDate.value,
        tel: this.form.tel.value
      }
      this.$store.commit('SET_USER_DATA', userData)
      this.$router.push('/passwordFindCertifyNext')
    },
    submitForm () {
      if (this.checkAll()) {
        this.nextDone()
      } else {
        if (!this.form.id.flag) {
          this.popupSet.content = '아이디를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.id.hasError = true
          this.form.id.errorTxt = '아이디를 확인해주세요.'
          document.querySelector('.idInput').focus()
          return false
        }
        if (!this.form.userName.flag) {
          this.popupSet.content = '이름을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.userName.hasError = true
          this.form.userName.errorTxt = '이름을 확인해주세요.'
          document.querySelector('.userInput').focus()
          return false
        }
        if (!this.form.tel.flag) {
          this.popupSet.content = '메일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.tel.hasError = true
          this.form.tel.errorTxt = '메일을 확인해주세요.'
          document.querySelector('.mailInput').focus()
          return false
        }
        if (!this.form.birthDate.flag) {
          this.popupSet.content = '생년월일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.birthDate.hasError = true
          this.form.birthDate.errorTxt = '생년월일을 확인해주세요.'
          document.querySelector('.birthInput').focus()
          return false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
